module.exports = __webpack_public_path__ + "img/luna menguante.2537de49.svg";